/**
 * @desc 导出初审单
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.firstTrialOrder.exporting.Params, options?: any) {
  return updateResponse(
    http(URL + `/wms/firstTrialOrder/export`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
